import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

function Terms() {
  const { theme } = useTheme();
  const tokens = theme.tokens;
  const tc = tokens.colors;

  const cardStyle = {
    background: `color-mix(in srgb, ${tc.surface} 75%, transparent)`,
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(6px)',
    border: `1px solid ${tc.gridLine}`,
    borderRadius: 14,
    padding: '32px 36px',
    marginTop: 24,
  };

  const h1Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 'clamp(24px, 5vw, 32px)',
    fontWeight: 600,
    color: tc.ink,
    marginBottom: 20,
    lineHeight: 1.2,
  };

  const h2Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 20,
    fontWeight: 600,
    color: tc.ink,
    marginTop: 28,
    marginBottom: 10,
  };

  return (
    <div className="container mx-auto px-4 sm:px-8 pb-12" style={{ color: tc.muted, fontFamily: tokens.fonts.ui, textAlign: 'left' }}>
      <div style={cardStyle}>
        <Helmet>
          <title>Terms of Service | ATLTech.events</title>
          <meta name="description" content="The terms of service for using ATLTech.events, Atlanta's tech events calendar." />
        </Helmet>
        <h1 style={h1Style}>Terms of Service</h1>

        <div className="space-y-4">
          <p style={{ fontWeight: 600, color: tc.ink }}>Last Updated: April 5, 2025</p>

          <section className="mb-6">
            <h2 style={h2Style}>1. Acceptance of Terms</h2>
            <p>
              By accessing and using ATLTech.events<sup>SM</sup> (atltech.events), you accept and agree to be
              bound by the terms and provisions of this agreement.
            </p>
          </section>

          <section className="mb-6">
            <h2 style={h2Style}>2. Use License</h2>
            <p>
              Permission is granted to temporarily view the materials (information or software) on
              ATLTech.events<sup>SM</sup> for personal, non-commercial transitory viewing only.
            </p>
          </section>

          <section className="mb-6">
            <h2 style={h2Style}>3. Disclaimer</h2>
            <p>
              The materials on ATLTech.events<sup>SM</sup> are provided on an 'as is' basis. We make no
              warranties, expressed or implied, and hereby disclaim and negate all other warranties
              including, without limitation, implied warranties or conditions of merchantability,
              fitness for a particular purpose, or non-infringement of intellectual property or
              other violation of rights.
            </p>
          </section>

          <section className="mb-6">
            <h2 style={h2Style}>4. Event Information</h2>
            <p>
              While we strive to maintain accurate and up-to-date event information, we cannot
              guarantee the accuracy of all event details. Users should verify event details with
              the respective event organizers.
            </p>
          </section>

          <section>
            <h2 style={h2Style}>5. Limitations</h2>
            <p>
              In no event shall ATLTech.events<sup>SM</sup>, its publisher Mirability, LLC, or its suppliers be liable for any damages
              (including, without limitation, damages for loss of data or profit, or due to business
              interruption) arising out of the use or inability to use the materials on ATLTech.events<sup>SM</sup>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Terms;
